import { useAuthStore } from '../store/useAuthStore';

export const PERMISSIONS = {
  // Action Permissions
  DISPLAY: 'DISPLAY',
  DOWNLOADS: 'DOWNLOADS',
  SHARE: 'SHARE',
  EXPORT: 'EXPORT',
  EXPORT_TRANSACTIONS: 'EXPORT_TRANSACTIONS',
  
  // Feature Permissions
  VIEW_PRODUCTS: 'VIEW_PRODUCTS',
  MANAGE_SUBSCRIPTIONS: 'MANAGE_SUBSCRIPTIONS',
  VIEW_TRANSACTIONS: 'VIEW_TRANSACTIONS',
  VIEW_API_KEYS: 'VIEW_API_KEYS',
  MANAGE_API_KEYS: 'MANAGE_API_KEYS',
  VIEW_SETTINGS: 'VIEW_SETTINGS',
  MANAGE_SETTINGS: 'MANAGE_SETTINGS',
  MANAGE_WEBHOOKS: 'MANAGE_WEBHOOKS',
  MANAGE_TEAM: 'MANAGE_TEAM',
  VIEW_PRICING: 'VIEW_PRICING',

  // Legacy/Specific
  SUBSCRIBE_PRODUCT: 'SUBSCRIBE_PRODUCT',
  MANAGE_LIVE_PRODUCT: 'MANAGE_LIVE_PRODUCT',
};

export const PERMISSION_LIST = Object.values(PERMISSIONS);

/**
 * Checks if a user has a specific permission.
 * @param {string[]} userPermissions
 * @param {string|string[]} requiredPermission
 * @param {string} userRole
 * @returns {boolean}
 */
export const hasPermission = (userPermissions, requiredPermission, userRole = null) => {
  if (userRole === 'OWNER') return true;
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  if (!requiredPermission) return true;

  const required = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
  return required.some(p => userPermissions.includes(p));
};

/**
 * Hook to check permissions within components.
 * @returns {Object} - Object containing permission check functions.
 */

export const usePermissions = () => {
  const { user } = useAuthStore();
  const userPermissions = user?.permissions || [];
  const userRole = user?.role;

  return {
    permissions: userPermissions,
    can: (requiredPermission) => hasPermission(userPermissions, requiredPermission, userRole),
    isAdmin: userRole === 'ADMIN' || userRole === 'OWNER',
    userRole,
  };
};
